import { TabsCustom } from 'app/components/elements/TabsCutom';
import { Stack, styled, Typography } from '@mui/material';
import React, { useCallback } from 'react';
import { headerTabValidations, TAB_VALIDATIONS } from './const';
import { useInjection } from './hook';
import { MemoAssetModelTab } from './components/modules/AssetModel';
import { MemoAssetTypeTab } from './components/modules/AssetTypes';
import { MemoAssetValidationTab } from './components/modules/AssetValidation';
import { MemoRoomLevelIssuesTab } from './components/modules/RoomIssues';
import { MemoTriggerTypesTab } from './components/modules/TriggerTypes';

export const ValidationsPage = () => {
  const {
    pagingInfoAssetModel,
    onChangeTab,
    searchParams,
    dataAssetModel,
    onSearch,
    handleChangePage,
    searchText,
    handleSort,
    sortOption,
    refreshDataModels,
    pagingInfoAssetTypes,
    refreshDataTypes,
    dataAssetTypes,
    tab,
    refreshDataValidation,
    pagingInfoAssetValidation,
    dataAssetValidation,
    onEditSubmittedEntries,
    filterValidations,
    setFilterValidations,
    dataRoomLevelIssues,
    pagingInfoRoomLevelIssues,
    refreshDataRoomLevelIssues,
    setDataAssetValidation,
    setFilterRoomIssues,
    filterRoomIssues,
    dateValidationAsset,
    asyncHandleSelectGenerate,
    setDateValidationAsset,
    options,
    onFilterCriticality,
    selectedCriticality,
    maintainanceSelectedDate,
    maintainanceSelectedType,
    setSelectedMaintainanceDate,
    setSelectedMaintainanceType,
    searchType,
    setSearchType,
    archiveRoomIssuesFilter,
    setArchiveRoomIssuesFilter,
    asyncExportAssetTypes,
    asyncExportAssetModels,
    asyncExportRoomIssues,
    expandedSubmittedAssetId,
    setExpandedSubmittedAssetId,
    refreshOptions
  } = useInjection();
  const renderTab = useCallback(() => {
    const tab = searchParams.get('tab') || TAB_VALIDATIONS.ASSET_VALIDATIONS;
    if (tab === TAB_VALIDATIONS.ASSET_MODEL) {
      return (
        <MemoAssetModelTab
          refreshDataModels={refreshDataModels}
          initSearchText={searchText.assetModel}
          handleChangePage={handleChangePage}
          pagingInfo={pagingInfoAssetModel}
          onSearch={onSearch}
          handleSort={handleSort}
          sortOption={sortOption}
          dataAssetModel={dataAssetModel}
          onExport={asyncExportAssetModels}
          refreshOptions={refreshOptions}
        />
      );
    }
    if (tab === TAB_VALIDATIONS.ASSET_TYPES) {
      return (
        <MemoAssetTypeTab
          refreshDataAssetTypes={refreshDataTypes}
          initSearchText={searchText.assetType}
          handleChangePage={handleChangePage}
          pagingInfo={pagingInfoAssetTypes}
          onSearch={onSearch}
          handleSort={handleSort}
          sortOption={sortOption}
          dataAssetTypes={dataAssetTypes}
          onExport={asyncExportAssetTypes}
        />
      );
    }
    if (tab === TAB_VALIDATIONS.TRIGGER_TYPES) {
      return <MemoTriggerTypesTab />;
    }
    if (tab === TAB_VALIDATIONS.ROOM_ISSUES) {
      return (
        <MemoRoomLevelIssuesTab
          searchType={searchType}
          setSearchType={setSearchType}
          archiveFilter={archiveRoomIssuesFilter}
          setArchiveFilter={setArchiveRoomIssuesFilter}
          initSearchText={searchText.roomIssues}
          dataRoomLevelIssues={dataRoomLevelIssues}
          pagingInfo={pagingInfoRoomLevelIssues}
          handleChangePage={handleChangePage}
          handleSort={handleSort}
          sortOption={sortOption}
          onSearch={onSearch}
          filterRoomIssues={filterRoomIssues}
          setFilterRoomIssues={setFilterRoomIssues}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          options={options as any}
          onExport={asyncExportRoomIssues}
          refreshDataRoomLevelIssues={refreshDataRoomLevelIssues}
        />
      );
    }

    return (
      <MemoAssetValidationTab
        handleSelectGenerate={asyncHandleSelectGenerate}
        dateValidationAsset={dateValidationAsset}
        setDateValidationAsset={setDateValidationAsset}
        setDataAssetValidation={setDataAssetValidation}
        filterValidations={filterValidations}
        setFilterValidations={setFilterValidations}
        onEditSubmittedEntries={onEditSubmittedEntries}
        refreshDataValidation={refreshDataValidation}
        initSearchText={searchText.assetValidation}
        handleChangePage={handleChangePage}
        pagingInfo={pagingInfoAssetValidation}
        onSearch={onSearch}
        handleSort={handleSort}
        sortOption={sortOption}
        dataAssetValidation={dataAssetValidation}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        options={options as any}
        onFilterCriticality={onFilterCriticality}
        selectedCriticality={selectedCriticality}
        maintainanceSelectedDate={maintainanceSelectedDate}
        maintainanceSelectedType={maintainanceSelectedType}
        setSelectedMaintainanceDate={setSelectedMaintainanceDate}
        setSelectedMaintainanceType={setSelectedMaintainanceType}
        searchType={searchType}
        setSearchType={setSearchType}
        expandedSubmittedAssetId={expandedSubmittedAssetId}
        onExpandedSubmittedAssetChange={setExpandedSubmittedAssetId}
      />
    );
  }, [
    searchParams,
    asyncHandleSelectGenerate,
    dateValidationAsset,
    setDateValidationAsset,
    setDataAssetValidation,
    filterValidations,
    setFilterValidations,
    onEditSubmittedEntries,
    refreshDataValidation,
    searchText.assetValidation,
    searchText.assetModel,
    searchText.assetType,
    searchText.roomIssues,
    handleChangePage,
    pagingInfoAssetValidation,
    onSearch,
    handleSort,
    sortOption,
    dataAssetValidation,
    options,
    onFilterCriticality,
    selectedCriticality,
    maintainanceSelectedDate,
    maintainanceSelectedType,
    setSelectedMaintainanceDate,
    setSelectedMaintainanceType,
    searchType,
    setSearchType,
    refreshDataModels,
    pagingInfoAssetModel,
    dataAssetModel,
    refreshDataTypes,
    pagingInfoAssetTypes,
    dataAssetTypes,
    dataRoomLevelIssues,
    pagingInfoRoomLevelIssues,
    refreshDataRoomLevelIssues,
    filterRoomIssues,
    setFilterRoomIssues,
    expandedSubmittedAssetId,
    setExpandedSubmittedAssetId,
    asyncExportAssetModels,
    asyncExportAssetTypes,
    asyncExportRoomIssues,
    refreshOptions,
    archiveRoomIssuesFilter,
    setArchiveRoomIssuesFilter
  ]);
  return (
    <WrapperPage>
      <TitleStyled>Validations</TitleStyled>
      <TabsCustom
        contentTab={renderTab()}
        tab={Number(tab) || 0}
        headerTab={headerTabValidations}
        onChangeTab={onChangeTab}
      />
    </WrapperPage>
  );
};
const WrapperPage = styled(Stack)(() => ({
  padding: '54px 40px ',
  width: '100%',
  minHeight: '100vh',
  gap: 20
}));
const TitleStyled = styled(Typography)(() => ({
  color: '#226AAA',
  fontSize: '24px',
  fontWeight: 900
}));
